import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DateInput, type ErrorSummaryItem } from '../../../components/idsk';
import { useWizard } from './WizardContext';
import { WizardStep } from './WizardStep';
import { validateStep3, type StepErrors } from './validation';

export function Step3Timeframe() {
  const { t } = useTranslation();
  const { state, update } = useWizard();
  const [errors, setErrors] = useState<StepErrors>({});
  const [submitCount, setSubmitCount] = useState(0);
  const onContinue = () => {
    const e = validateStep3(state);
    setErrors(e);
    setSubmitCount((c) => c + 1);
    return Object.keys(e).length === 0;
  };
  const target = (id: string, parts?: string[]) => `${id}-${parts?.[0] ?? 'day'}`;
  const summary: ErrorSummaryItem[] = [
    ...(errors.dateFrom ? [{ targetId: target('dateFrom', errors.dateFrom.parts), text: t(errors.dateFrom.key) }] : []),
    ...(errors.dateTo ? [{ targetId: target('dateTo', errors.dateTo.parts), text: t(errors.dateTo.key) }] : []),
  ];
  return (
    <WizardStep step={3} title={t('wizard.step3.title')} errors={summary} submitCount={submitCount} onContinue={onContinue}>
      <DateInput
        id="dateFrom"
        namePrefix="dateFrom"
        legend={t('wizard.step3.from')}
        required
        legendClassName="govuk-fieldset__legend--m"
        hint={t('wizard.step3.hint')}
        error={errors.dateFrom ? t(errors.dateFrom.key) : undefined}
        errorParts={errors.dateFrom?.parts}
        value={state.dateFrom}
        onChange={(dateFrom) => update({ dateFrom })}
      />
      <DateInput
        id="dateTo"
        namePrefix="dateTo"
        legend={t('wizard.step3.to')}
        required
        legendClassName="govuk-fieldset__legend--m"
        hint={t('wizard.step3.hint')}
        error={errors.dateTo ? t(errors.dateTo.key) : undefined}
        errorParts={errors.dateTo?.parts}
        value={state.dateTo}
        onChange={(dateTo) => update({ dateTo })}
      />
    </WizardStep>
  );
}
